import React, { useState } from 'react';

const WhatIncludedSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const services = [
    {
      icon: '/images/icons/funnel.webp',
      title: 'ПОСТРОЕНИЕ ВОРОНКИ ПРОДАЖ',
      text: 'Мы проводим анализ Вашего магазина и выстраиваем воронку продаж по каждому артикулу. Аудит коснется конверсий и цифр. Отразим это все в таблице, которая останется у Вас.',
      rotate: -6,
    },
    {
      icon: '/images/icons/analytics.webp',
      title: 'БЮДЖЕТ И ПРОГНОЗ',
      text: 'На основе полученных цифр мы сведем их с цифрами рынка (из аналитических систем) и предоставим Вам прогноз по выручке и расходам на площадке маркетплейса.',
      rotate: 5,
    },
    {
      icon: '/images/icons/card.webp',
      title: 'УЛУЧШЕНИЕ КАРТОЧЕК',
      text: 'Усилим Ваши карточки, насколько требует прогноз. Например, мы знаем, что Ваша конверсия должна быть 5% из поиска в карточку, а у Вас 1%. Мы изменим инфографику так, чтобы стало 5%',
      rotate: -4,
    },
    {
      icon: '/images/icons/rocket.webp',
      title: 'ЗАПУСК ПРОДВИЖЕНИЯ',
      text: 'Запускаем рекламные инструменты с минимальными бюджетами и сразу показываем результат. Всё в рамках бюджета и строгих цифр, чтобы Вы получили прибыль и рост позиций в поисковой выдаче.',
      rotate: 6,
    },
    {
      icon: '/images/icons/chart.webp',
      title: 'РЕГУЛЯРНАЯ ОТЧЕТНОСТЬ',
      text: 'Самая глубокая отчетность, что есть на рынке, ежедневно, прямо Вам в чат. Наглядно, прозрачно и выгодно.',
      rotate: -5,
    },
  ];

  return (
    <section
      id="services"
      className="included-section"
      style={{
        background: '#FFFFFF',
        padding: '100px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные полукруги на фоне */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        {/* Полукруг 1 - cyan-violet */}
        <div
          style={{
            position: 'absolute',
            width: '300px',
            height: '300px',
            top: '-150px',
            left: '-100px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
            filter: 'blur(60px)',
            opacity: 0.15,
          }}
        />

        {/* Полукруг 2 - pink-gold */}
        <div
          style={{
            position: 'absolute',
            width: '250px',
            height: '250px',
            top: '40%',
            left: '10%',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #EC4899, #FBBF24)',
            filter: 'blur(50px)',
            opacity: 0.15,
          }}
        />

        {/* Полукруг 3 - violet-pink */}
        <div
          style={{
            position: 'absolute',
            width: '350px',
            height: '350px',
            bottom: '-100px',
            right: '-100px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #8B5CF6, #EC4899)',
            filter: 'blur(70px)',
            opacity: 0.15,
          }}
        />

        {/* Декоративные иконки на фоне */}
        <img
                loading="lazy"
          src="/images/icons/funnel.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '8%',
            left: '5%',
            transform: 'rotate(-12deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatIncluded1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/analytics.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '12%',
            right: '6%',
            transform: 'rotate(10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatIncluded2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/card.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '15%',
            left: '4%',
            transform: 'rotate(8deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatIncluded3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '18%',
            right: '5%',
            transform: 'rotate(-10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatIncluded4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Заголовок */}
        <div
          className="included-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            marginBottom: '80px',
          }}
        >
          <span
            style={{
              background: 'rgba(15, 15, 26, 0.08)',
              color: '#0F0F1A',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            ЧТО ВХОДИТ
          </span>

          <h2
            style={{
              fontSize: '42px',
              fontWeight: 800,
              color: '#0F0F1A',
              textTransform: 'uppercase',
              lineHeight: 1.1,
              margin: 0,
            }}
            className="included-title"
          >
            ЧТО ВХОДИТ В
            <br />
            ПРОДВИЖЕНИЕ?
          </h2>
        </div>

        {/* Сетка карточек */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '80px 24px',
          }}
          className="included-grid"
        >
          {/* 5 карточек услуг */}
          {services.map((service, index) => (
            <div
              key={index}
              style={{
                position: 'relative',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Карточка */}
              <div
                className="included-card"
                style={{
                  background: '#F8F9FA',
                  border: '1px solid rgba(15, 15, 26, 0.06)',
                  borderRadius: '24px',
                  padding: '28px',
                  minHeight: '280px',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  transform: hoveredIndex === index ? 'translateY(-4px)' : 'translateY(0)',
                  boxShadow:
                    hoveredIndex === index
                      ? '0 20px 40px rgba(139, 92, 246, 0.15), 0 0 60px rgba(236, 72, 153, 0.1)'
                      : '0 4px 24px rgba(15, 15, 26, 0.04)',
                  borderColor: hoveredIndex === index ? 'rgba(139, 92, 246, 0.2)' : 'rgba(15, 15, 26, 0.06)',
                }}
              >
                <h3
                  style={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#0F0F1A',
                    textTransform: 'uppercase',
                    lineHeight: 1.2,
                    margin: '0 0 12px 0',
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: 'rgba(15, 15, 26, 0.6)',
                    lineHeight: 1.6,
                    margin: '0 0 16px 0',
                    paddingRight: '100px',
                  }}
                >
                  {service.text}
                </p>
              </div>

              {/* Иконка в правом нижнем углу - выходит за границы */}
              <div
                className="included-icon-wrap"
                style={{
                  position: 'absolute',
                  bottom: '-20px',
                  right: '-20px',
                  zIndex: 3,
                }}
              >
                {/* Glow эффект */}
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '182px',
                    height: '182px',
                    background: 'radial-gradient(circle, rgba(249, 115, 22, 0.35) 0%, rgba(236, 72, 153, 0.25) 40%, transparent 70%)',
                    filter: 'blur(18px)',
                    zIndex: -1,
                    pointerEvents: 'none',
                    opacity: hoveredIndex === index ? 1 : 0.7,
                    transition: 'opacity 0.3s ease',
                  }}
                />

                {/* Иконка */}
                <img
                loading="lazy"
                  src={service.icon}
                  alt=""
                  style={{
                    width: '130px',
                    height: '130px',
                    objectFit: 'contain',
                    position: 'relative',
                    zIndex: 1,
                    transform: hoveredIndex === index
                      ? `rotate(${service.rotate + 15}deg) scale(1.1)`
                      : `rotate(${service.rotate}deg)`,
                    transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  }}
                />
              </div>
            </div>
          ))}

          {/* CTA карточка */}
          <div
            style={{
              position: 'relative',
            }}
            onClick={() => window.dispatchEvent(new Event('openModal'))}
            onMouseEnter={(e) => {
              const card = e.currentTarget.querySelector('.cta-card');
              const icon = e.currentTarget.querySelector('.cta-icon');
              if (card) {
                card.style.transform = 'translateY(-4px)';
                card.style.boxShadow = '0 20px 40px rgba(249, 115, 22, 0.4)';
              }
              if (icon) {
                icon.style.transform = 'scale(1.1)';
              }
            }}
            onMouseLeave={(e) => {
              const card = e.currentTarget.querySelector('.cta-card');
              const icon = e.currentTarget.querySelector('.cta-icon');
              if (card) {
                card.style.transform = 'translateY(0)';
                card.style.boxShadow = 'none';
              }
              if (icon) {
                icon.style.transform = 'scale(1)';
              }
            }}
          >
            <div
              className="cta-card"
              style={{
                background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
                borderRadius: '24px',
                padding: '32px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '280px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
              }}
            >
              <h3
                style={{
                  fontSize: '24px',
                  fontWeight: 700,
                  color: '#FFFFFF',
                  textTransform: 'uppercase',
                  lineHeight: 1.2,
                  margin: 0,
                }}
              >
                ОСТАВИТЬ
                <br />
                ЗАЯВКУ НА
                <br />
                ПРОДВИЖЕНИЕ
              </h3>
            </div>

            {/* Иконка в правом нижнем углу - выходит за границы */}
            <div
              style={{
                position: 'absolute',
                bottom: '-20px',
                right: '-20px',
                zIndex: 3,
                cursor: 'pointer',
              }}
            >
              {/* Glow эффект */}
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '120px',
                  height: '120px',
                  background: 'radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.25) 40%, transparent 70%)',
                  filter: 'blur(18px)',
                  zIndex: -1,
                  pointerEvents: 'none',
                }}
              />

              {/* Иконка taptap */}
              <img
                loading="lazy"
                className="cta-icon"
                src="/images/icons/taptap.webp"
                alt=""
                style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'contain',
                  position: 'relative',
                  zIndex: 1,
                  transition: 'transform 0.3s ease',
                  animation: 'iconFloat 3s ease-in-out infinite',
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Анимации */}
      <style>
        {`
          @media (max-width: 768px) {
            .included-section { padding: 50px 0 !important; }
            .included-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; margin-bottom: 40px !important; }
            .included-title { font-size: 28px !important; }
            .included-grid { grid-template-columns: 1fr !important; gap: 40px 0 !important; }
            .included-card { min-height: auto !important; padding: 16px 20px 16px !important; text-align: center !important; }
            .included-card h3 { font-size: 16px !important; }
            .included-card p { padding-right: 0 !important; margin-bottom: 0 !important; font-size: 13px !important; }
            .included-icon-wrap { bottom: auto !important; top: -45px !important; right: auto !important; left: 12px !important; }
            .included-icon-wrap img { width: 70px !important; height: 70px !important; }
            .included-icon-wrap > div:first-child { width: 90px !important; height: 90px !important; }
            /* Чередование: чётные — справа */
            .included-grid > div:nth-child(even) .included-icon-wrap { left: auto !important; right: 16px !important; }
            .cta-card { min-height: auto !important; padding: 20px !important; }
            .included-bg-icon { display: none !important; }
          }
          @media (max-width: 480px) {
            .included-title { font-size: 24px !important; }
            .included-section { padding: 40px 0 !important; }
          }

          /* Тонкая анимация для всех иконок */
          @keyframes iconFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }

          /* Анимации плавающих иконок на фоне */
          @keyframes floatIncluded1 {
            0%, 100% { transform: translate(0, 0) rotate(-12deg); }
            50% { transform: translate(-10px, -12px) rotate(-12deg); }
          }

          @keyframes floatIncluded2 {
            0%, 100% { transform: translate(0, 0) rotate(10deg); }
            50% { transform: translate(10px, -14px) rotate(10deg); }
          }

          @keyframes floatIncluded3 {
            0%, 100% { transform: translate(0, 0) rotate(8deg); }
            50% { transform: translate(-12px, -10px) rotate(8deg); }
          }

          @keyframes floatIncluded4 {
            0%, 100% { transform: translate(0, 0) rotate(-10deg); }
            50% { transform: translate(14px, -12px) rotate(-10deg); }
          }
        `}
      </style>
    </section>
  );
};

export default WhatIncludedSection;
